import React from "react";
import { MapWorkspacePanel } from "./FmMapWorkspacePanels";
import type {
  FmMapFilterValues,
  FmMapBasemapDescriptor,
  FmMapPanelDescriptor,
  FmMapLayerId,
  FmMapWorkspaceDescriptor,
} from "./FmMapWorkspaceRoot.types";
import type { FmMapEmitFilter } from "./useMapWorkspaceFilters";

export const MapWorkspacePanelContent: React.FC<{
  activeBaseMapId: FmMapWorkspaceDescriptor["activeBaseMapId"];
  baseMaps: FmMapWorkspaceDescriptor["baseMaps"];
  emitFilter: FmMapEmitFilter;
  filterValues: FmMapFilterValues;
  filters: FmMapWorkspaceDescriptor["filters"];
  layers: FmMapWorkspaceDescriptor["layers"];
  onEvent: FmMapWorkspaceDescriptor["onEvent"];
  panel: FmMapPanelDescriptor;
  toggleLayer: (layerId: FmMapLayerId, enabled: boolean) => void;
  selectBaseMap: (baseMapId: FmMapBasemapDescriptor["id"]) => void;
}> = ({
  activeBaseMapId,
  baseMaps,
  emitFilter,
  filterValues,
  filters,
  layers,
  onEvent,
  panel,
  toggleLayer,
  selectBaseMap,
}) => (
  <MapWorkspacePanel
    panel={panel}
    layers={layers}
    baseMaps={baseMaps}
    activeBaseMapId={activeBaseMapId}
    filters={filters}
    filterValues={filterValues}
    onFilterChange={(filterId, values) => emitFilter(filterId, values, "panel")}
    onLayerToggle={toggleLayer}
    onBaseMapSelect={selectBaseMap}
    onAction={(actionId) => onEvent?.({ kind: "action", actionId })}
    onCollectionSelect={(panelId, recordId) =>
      onEvent?.({ kind: "collection-select", panelId, recordId })
    }
  />
);
